import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#533A7B",
        secondary: "#6969B3",
        accent: "#00BFA5"
      },
      dark: {
        primary: "#724cb0",
        secondary: "#6969B3",
        accent: "#00BFA5"
      }
    }
  }
});
